export default "__VITE_ASSET__dbdcdd5f__"